"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SingleLineTextGeneralHandler", {
    enumerable: true,
    get: function() {
        return SingleLineTextGeneralHandler;
    }
});
const _longtextgeneralhandler = require("../long-text/long-text.general.handler");
let SingleLineTextGeneralHandler = class SingleLineTextGeneralHandler extends _longtextgeneralhandler.LongTextGeneralHandler {
};
